export const IMPORT_WARNING_MESSAGE_PREFIX = 'Import completed with ';

export type ImportWarningReason =
  | 'ambiguous'
  | 'unresolved'
  | 'fbxAxisHeuristic'
  | 'udimExternal'
  | 'udimMissing'
  | 'udimUnsupported'
  | 'udimTextureLimit';

export type ImportWarningDetail = {
  label: string;
  reason: ImportWarningReason;
  contexts: string[];
};

export function formatImportWarningMessage(
  count: number,
  summary: string,
): string {
  return `${IMPORT_WARNING_MESSAGE_PREFIX}${count} warning(s). ${summary}`;
}
